import { buttonClasses, DialogContent, inputClasses, inputLabelClasses, InputLabel, MenuItem, menuItemClasses, FormControl, FormControlLabel, Checkbox, Button, radioClasses, typographyClasses, RadioGroup, TextField, selectClasses, Radio } from "@mui/material";
import { styled } from "@mui/material/styles";
import AvatarIcon from "./assets/icons/Avatar.js";
import ImportantIcon from "./assets/icons/Important.js";
import TaskCategoryIcon from "./assets/icons/TaskCategory.js";
import TaskDescriptionIcon from "./assets/icons/TaskDescription.js";
import TaskNameIcon from "./assets/icons/TaskName.js";
import "react/jsx-runtime";
const Actions = styled("div")(() => ({
  boxShadow: "0px -3px 3px -3px #e5e5e5",
  padding: "8px 0 0 0",
  [`.${buttonClasses.root}`]: {
    textTransform: "none"
  }
}));
const ButtonsWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  width: "100%"
}));
const Content = styled(DialogContent)(() => ({
  padding: "0 0 16px",
  width: "100%"
}));
const InputWrapper = styled("div")(() => ({
  width: "100%",
  [`.${inputClasses.root}`]: {
    borderColor: "#00725E",
    paddingTop: 16,
    marginTop: 0,
    fontSize: 15,
    fontFamily: "Lato,sans-serif",
    [`&.${inputClasses.error}`]: {
      backgroundColor: "#FEF1F3",
      color: "#B5223B",
      "&:after": {
        borderColor: "#B5223B"
      }
    },
    "&:after, &:before": {
      borderColor: "#00725E"
    }
  },
  [`.${inputClasses.root}:hover:not(.${inputClasses.disabled}):before`]: {
    borderBottom: `2px solid #00725E`
  },
  [`.${inputLabelClasses.root}`]: {
    color: "#00725E",
    fontWeight: 700,
    fontSize: 15,
    marginLeft: 32,
    zIndex: 2,
    marginTop: 4,
    fontFamily: "Lato,sans-serif",
    [`&.${inputLabelClasses.focused}`]: {
      color: "#00725E"
    },
    [`&.${inputLabelClasses.error}`]: {
      color: "#B5223B"
    }
  }
}));
const TaskNameFieldLabel = styled(InputLabel)(() => ({
  transform: "translate(48px, 4px) scale(0.75)",
  fontWeight: "bold",
  color: "#00725E",
  fontFamily: "Lato,sans-serif"
}));
const DescriptionIcon = styled(TaskDescriptionIcon)(() => ({
  marginBottom: "14px",
  color: "#00725E"
}));
const StyledMenuItem = styled(MenuItem)(() => ({
  [`&.${menuItemClasses.root}`]: {
    paddingTop: 12,
    paddingBottom: 12,
    color: "#004734",
    backgroundColor: "#fff",
    fontFamily: "Lato,sans-serif",
    [`&:hover:not(.${menuItemClasses.selected}, .${menuItemClasses.focusVisible})`]: {
      backgroundColor: "#caede7",
      [`span`]: {
        color: "#004734"
      }
    },
    [`&.${menuItemClasses.selected}, &.${menuItemClasses.focusVisible}, &.${menuItemClasses.selected}.${menuItemClasses.focusVisible}`]: {
      backgroundColor: "#00624F",
      color: "#fff",
      [`span`]: {
        color: "#fff"
      }
    },
    [`&.${menuItemClasses.selected}:hover, &.${menuItemClasses.selected}.${menuItemClasses.focusVisible}:hover, &.${menuItemClasses.focusVisible}:hover`]: {
      backgroundColor: "#004734"
    }
  }
}));
const Avatar = styled(AvatarIcon)(() => ({
  marginBottom: "14px",
  color: "#00725E"
}));
const AvatarCircle = styled("div")(() => ({
  width: "32px",
  height: "32px",
  borderRadius: "100px",
  display: "flex",
  justifyContent: "center",
  backgroundColor: "#E0E0E0",
  border: "2px solid #F5F5F5"
}));
const NameIcon = styled(TaskNameIcon)(() => ({
  marginBottom: "14px",
  color: "#00725E"
}));
const TaskFormControl = styled(FormControl)(() => ({
  marginTop: "10px"
}));
const ImportantFormControlLabel = styled(FormControlLabel)(() => ({
  marginTop: "10px",
  ["& .Mui-disabled"]: {
    color: "rgba(0, 0, 0, 0.38)",
    "-webkit-text-fill-color": "inherit"
  }
}));
const ImportantContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontFamily: "Lato,sans-serif"
}));
const Important = styled(ImportantIcon)(() => ({
  position: "relative",
  top: "2px",
  marginRight: "5px",
  alignSelf: "bottom"
}));
const ImportantLabel = styled("div")(() => ({
  position: "relative",
  verticalAlign: "middle",
  textTransform: "uppercase",
  fontSize: 11
}));
const CustomCheckbox = styled(Checkbox)(() => ({
  paddingLeft: "15px",
  ["&.MuiCheckbox-root.Mui-checked"]: {
    color: "#00624F"
  }
}));
const FormButton = styled(Button, { shouldForwardProp: (props) => props !== "$grey" })(
  ({ $grey }) => ({
    ...$grey && {
      backgroundColor: "#F5F5F5",
      ["&:hover"]: {
        backgroundColor: "#caede7"
      }
    }
  })
);
const CategoryFieldLabel = styled(InputLabel)(() => ({
  top: 6,
  left: "-14px"
}));
const CategoryIcon = styled(TaskCategoryIcon)(() => ({
  marginBottom: "14px",
  position: "absolute",
  color: "#00725E"
}));
const CategoryFormControl = styled(FormControl)(() => ({
  ".MuiInput-input": {
    ["&:focus"]: {
      background: "transparent"
    }
  }
}));
const RadioOption = styled("div")((p) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, max-content)",
  gridAutoFlow: "column",
  gridGap: p.theme.spacing(2),
  alignItems: "center",
  minHeight: "32px",
  height: "0",
  marginBottom: p.theme.spacing(1),
  [`.${radioClasses.root}`]: {
    marginTop: "-9px",
    marginBottom: "-9px"
  },
  [`.${typographyClasses.root}`]: {
    fontSize: 14
  }
}));
const Group = styled(RadioGroup)(() => ({
  marginTop: "6px"
}));
const SelectInput = styled(TextField)((p) => ({
  [`& .${inputClasses.root}`]: {
    textTransform: "none"
  },
  [`& .${selectClasses.select}`]: {
    paddingLeft: p.theme.spacing(3),
    textTransform: "none !important"
  },
  [`& .${typographyClasses.root}`]: {
    fontSize: "15px"
  }
}));
const AvatarContainer = styled("div")(() => ({
  background: "#E0E0E0",
  border: "2px solid #FAFAFA",
  width: "32px",
  height: "32px",
  borderRadius: "32px",
  display: "flex",
  marginLeft: "2px",
  justifyContent: "center",
  alignItems: "center"
}));
const PatientSearchAvatar = styled(AvatarIcon)(() => ({
  width: 18
}));
const Description = styled(TextField)(() => ({
  ["& input::placeholder"]: {
    fontSize: "13px"
  }
}));
const StyledRadio = styled(Radio)(() => ({
  color: "#00624F",
  [`&.${radioClasses.checked}`]: {
    color: "#00624F"
  },
  "&:hover": {
    background: "transparent"
  }
}));
const PatientSearchAutocomplete = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  fontWeight: "700",
  fontSize: "13px",
  border: "1px solid #00A08D",
  borderRadius: "32px",
  background: "#EDF8F7",
  marginTop: "12px",
  padding: "4px 0px",
  minHeight: "56px",
  width: "100%",
  "&:hover": {
    boxShadow: "0 0 0 0.5px #008F79"
  },
  "&&": {
    paddingRight: "8px"
  },
  ["&:hover::before,&:hover::after,&::before,&::after"]: {
    border: "none"
  },
  "& .MuiInputBase-root": {
    border: "none"
  },
  "&&& .MuiInputBase-sizeSmall": {
    fontWeight: "700",
    paddingTop: "0"
  },
  "&&& .MuiInputBase-inputSizeSmall": {
    padding: "2.5px 4px 2.5px 4px",
    color: "#212121",
    opacity: "1",
    "&::placeholder": {
      opacity: "1"
    }
  },
  "& .MuiInput-root:before": {
    border: "none"
  },
  "& .MuiInput-root:hover:not(.Mui-disabled):before": {
    border: "none"
  },
  "& .MuiInput-root:hover": {
    border: "none"
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none"
  },
  ".MuiInputBase-input:focus": {
    background: "transparent"
  },
  "& .MuiInputLabel-shrink": {
    paddingLeft: "8px",
    marginTop: "5px",
    fontWeight: 700
  },
  "& .MuiInputLabel-root > .Mui-focused": {
    display: "none"
  }
}));
export {
  Actions,
  Avatar,
  AvatarCircle,
  AvatarContainer,
  ButtonsWrapper,
  CategoryFieldLabel,
  CategoryFormControl,
  CategoryIcon,
  Content,
  CustomCheckbox,
  Description,
  DescriptionIcon,
  FormButton,
  Group,
  Important,
  ImportantContainer,
  ImportantFormControlLabel,
  ImportantLabel,
  InputWrapper,
  NameIcon,
  PatientSearchAutocomplete,
  PatientSearchAvatar,
  RadioOption,
  SelectInput,
  StyledMenuItem,
  StyledRadio,
  TaskFormControl,
  TaskNameFieldLabel
};
